(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './convert', './protect', './using'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./convert'), require('./protect'), require('./using'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.convert, global.protect, global.using);
    global.index = mod.exports;
  }
})(this, function (exports, _convert, _protect, _using) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.protect = exports.using = exports.convert = undefined;

  var _protect2 = _interopRequireDefault(_protect);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.convert = _convert.convert;
  exports.using = _using.using;
  exports.protect = _protect2.default;
});